<div class="container text-center">
	<div class="row mx-auto text-center">
		<a class="text-center text-decoration-none" id="n0">
			<img [src]="'assets/images/logos/kurdshopping.png' | s3Image" class="logo" />
		</a>
	</div>

	<h3 class="my-dialog-heading">{{ data?.title }}</h3>

	<p class="my-dialog-subheading">Please select your desired language below:</p>

	<div class="list-group select-lang">
		<button class="list-group-item" id="n2" (click)="onLanguageChange('en')">
			<img [src]="'assets/images/flags/english.png' | s3Image" class="lang-flag" />

			<span>{{ locale?.translations['header']['n2'] }}</span>
		</button>

		<button class="list-group-item" id="n3" (click)="onLanguageChange('ku')">
			<img [src]="'assets/images/flags/kurdistan.png' | s3Image" class="lang-flag" />

			<span>{{ locale?.translations['header']['n3'] }}</span>
		</button>

		<button class="list-group-item" id="n4" (click)="onLanguageChange('ar')">
			<img [src]="'assets/images/flags/iraq.png' | s3Image" class="lang-flag" />

			<span>{{ locale?.translations['header']['n4'] }}</span>
		</button>
	</div>
</div>
